//import packages from node modules
import React, { useRef, useEffect, useState, useCallback } from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"

//import utility functions
import PAYINVOICE_API from "../../../utilities/api/payinvoice"
import { isResponseCancelled  } from "../../../utilities/function/apiResponse"
import {getAppConfigValue} from "../../../utilities/function/configuration"
import { getErrorFromFailResponse } from "../../../utilities/errors/payinvoice-withref"
import { updatePopupNotification } from "../../../app/action"
import loadGoogleRecaptcha from "../../shared/googlerecaptcha"
import SmallLoading from '../../../utilities/images/small-loading.svg'
const PAY_INVOICE_CLASSNAME = "of-pay-invoice-connector"

//main component
export const PayInvoiceConnector = ({
  button_label,
  router,
  container,
}) => {
  const dispatch = useDispatch();
  const invoice_field = useRef(null);
  const { history } = router;

  const getPlaceholderInvoiceNumber = () => {
    if (width >= 510){
      return "Start by entering your invoice number here"
    } else if (width >= 400) {
      return "Enter invoice number here"
    } else {
      return "Invoice number"
    } 
  };


  const [width, setWidth] = React.useState(window.innerWidth);
  //const [height, setHeight] = React.useState(window.innerHeight);

  const updateWidthAndHeight = () => {
    setWidth(window.innerWidth);
    //setHeight(window.innerHeight);
  };

  
  React.useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  });

  const [isLoading, setIsLoading] = useState(false)
  const getButtonText = () => {
    if (isLoading) {
      return <img alt="" className={`${PAY_INVOICE_CLASSNAME}__loading`} src={SmallLoading}/>
    }
    if (width >= 320){
      return <>{button_label}</>
    } else {
      return <span className="icon-search"></span>
    }
  }

  const formSubmit = (e, token) => {
    let invoice_id = invoice_field.current.value
      ? invoice_field.current.value
      : null;

    if (invoice_id === "null" || invoice_id === null){
      setIsLoading(false)
      const fatalError = {
        data: {
          errors:[{
            details: 'Please enter in your invoice number.'
          }]
        }
      }
      updatePopupNotification(dispatch, {
        status: 'error',
        error: fatalError
      })
      return;
    }

    PAYINVOICE_API.checkInvoice(invoice_id, null, null, token).then(
      (successresponse) => {
        setIsLoading(false)
        history.push(
          `${history.location.pathname}?a=pay&step=payinvoice&ref=${invoice_id}`
        );
      },
      (errorresponse) => {
        setIsLoading(false)
        const error = getErrorFromFailResponse(errorresponse);
        if (!isResponseCancelled(error)) {
          updatePopupNotification(dispatch, {
            status: "error",
            error: error,
          });
        }
      }
    );
  };


  const render_placehold = () => {
    return <div> </div>;
  };

  const executeGoogleRecaptcha = (e) => {
    e.preventDefault();
    setIsLoading(true)
    let SITE_KEY = getAppConfigValue("google_site_key");
    loadGoogleRecaptcha(() => {

      window.grecaptcha.ready(function () {
        try{
        window.grecaptcha
          .execute(SITE_KEY, { action: "submit" })
          .then(function (token) {
            if (token){
              formSubmit(e, token);
            } else {
              setIsLoading(false)
            }
          });
        } catch (e){
       console.log(e);
       console.log('Likely invalid site key')
      }
      });
    
    });
  };

  const renderInvoiceIcon = () => {
    return (<span className={`${PAY_INVOICE_CLASSNAME}__invoice-icon icon-invoice`}></span>)
  }



    const [invoiceNumberValue, setInvoiceNumberValue] = useState('')
    const onChangeInvoiceNumber = (e) => {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        if (e.target.value.length <= 7){
          setInvoiceNumberValue(e.target.value)
        }
      }
  }



  //Render
  return ReactDOM.createPortal(
    <>
    <div className={`${PAY_INVOICE_CLASSNAME}__element clearfix`}>
      <form
        onSubmit={executeGoogleRecaptcha}
        className={`${PAY_INVOICE_CLASSNAME}__form clearfix`}
      >
        <div className={`${PAY_INVOICE_CLASSNAME}__wrapper clearfix`}>
          {renderInvoiceIcon()}
          <input
            onChange={onChangeInvoiceNumber}
            ref={invoice_field}
            value={invoiceNumberValue}
            className={`${PAY_INVOICE_CLASSNAME}__field ${PAY_INVOICE_CLASSNAME}__invoice-number`}
            placeholder={getPlaceholderInvoiceNumber()}
          />
          {render_placehold()}
          <button
            className={`${PAY_INVOICE_CLASSNAME}__button${
              button_label ? ` ${PAY_INVOICE_CLASSNAME}__button--label` : ""
            }`}
            id="submit"
            type={"submit"}
          >
            {getButtonText()}
          </button>
        </div>

      </form>
      </div>
    </>,
    container
  );
};

PayInvoiceConnector.propTypes = {
  button_label: PropTypes.string,
  placeholder: PropTypes.string,
  router: PropTypes.any,
  container: PropTypes.object,
};

export const RenderPayInvoiceConnector = (props) => {
  const [update, updateState] = useState(false);
  const { router } = props;
  const forceUpdate = useCallback(() => {
    updateState(!update);
  }, [update, updateState]);
  useEffect(() => {
    window.updateSearchDomain = forceUpdate;
  }, [forceUpdate]);
  const domlist = Array.from(
    document.querySelectorAll(`.${PAY_INVOICE_CLASSNAME}`)
  );
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const button_label = el.getAttribute("data-button-label");
      return (
        <PayInvoiceConnector
          button_label={button_label}
          key={index}
          container={el}
          router={router}
        />
      );
    });
  }
  return <></>;
};

RenderPayInvoiceConnector.propTypes = {
  router: PropTypes.object,
};
